const ITEMS = [
  "YIIS-100 — IPO INTELLIGENCE EDITION",
  "OPERATION BLUE • V1.0",
  "PRECISION ENGINEERED BY YKD ENTERPRISES",
  "IPO ACCOUNT MANAGEMENT",
  "ALLOTMENT & LISTING TRACKING",
  "PROFIT / LOSS INTELLIGENCE",
];

export const Marquee = () => (
  <div
    className="relative border-y border-border py-5 overflow-hidden select-none"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-mono text-sm tracking-[0.3em] uppercase text-muted-foreground px-8">
                {item}
              </span>
              <span className="w-1.5 h-1.5 bg-accent rotate-45" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
